import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription, switchMap, tap } from 'rxjs';
import { publicEventApi } from 'src/app/services/constants/api.constants';
import { AuthService, HelpersService, HttpBaseService } from '@evento-ng/libs';
import { Meta, Title } from '@angular/platform-browser';
import { ACCESS_TOKEN } from 'src/app/services/constants/general.constants';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { LoginPopupComponent } from 'src/app/shared-components/login-popup/login-popup.component';
import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import { SalesStatusEnum } from 'src/app/services/enums/sales-event.enum';
registerLocaleData(localeAr);

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.scss'],
})
export class EventDetailsComponent implements OnInit, OnDestroy {
  subs: Subscription[] = [];
  event: any;
  eventLocationLink: string = '';
  mobileDevice = false;
  openPloliciesMobile = false;
  // isAuthenticated!: boolean;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public helpers: HelpersService,
    public translate: TranslateService,
    private dataService: HttpBaseService,
    private titleService: Title,
    private meta: Meta,
    private modalService: NgbModal,
    public authService: AuthService
  ) {
    // this.isAuthenticated = authService.isAuthenticated();
  }

  openRegisterModal(): void {
    if (
      !this.helpers.checkItemFromLocalStorage(ACCESS_TOKEN) &&
      this.event.eventSetting.requireAuthentication
    ) {
      let ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,

        centered: true,
      };
      const modalRef = this.modalService.open(
        LoginPopupComponent,
        ngbModalOptions
      );
      modalRef.dismissed.subscribe((result) => {
        if (result) {
        }
      });
    } else {
      this.router.navigate(['book'], {
        queryParams: {
          eventId: this.event.id,
        },
        relativeTo: this.route.parent,
      });
    }
  }

  getLeastPrice() {
    const activeTickets = this.event.tickets.filter(
      (ticket: any) => ticket.status === 'ACTIVE'
    );

    if (activeTickets.length > 0) {
      const leastActivePrice = Math.min(
        ...activeTickets.map((ticket: any) => ticket.price)
      );
      return leastActivePrice === 0 ? 0 : leastActivePrice;
    }

    const otherTickets = this.event.tickets.filter(
      (ticket: any) => ticket.status !== 'INACTIVE'
    );

    if (otherTickets.length > 0) {
      return Math.min(...otherTickets.map((ticket: any) => ticket.price));
    }

    return -1;
  }

  ngOnInit(): void {
    this.spinner.show();
    if (window.screen.width <= 768) {
      this.mobileDevice = true;
    }
    this.subs.push(
      this.route.params
        .pipe(
          tap(() => {}),
          switchMap((params) =>
            this.dataService
              .get(`${publicEventApi}/${params['id']}`, {
                headers: { 'Accept-Language': this.translate.currentLang },
              })
              .pipe(
                tap((event) => {
                  this.event = event;
                  // if (event.image?.image && event.gallery.length > 0) {
                  //   event.gallery.push(event.image.image);
                  // } else if (event.image?.image && event.gallery.length === 0) {
                  //   event.gallery.push(event.image.image);
                  // } else if (
                  //   !event.image?.image &&
                  //   event.gallery.length === 0
                  // ) {
                  //   event.gallery.push({
                  //     url: 'assets/images/placeholder-img.jpg',
                  //   });
                  // }

                  this.titleService.setTitle(event?.nameAr);
                  this.meta.addTag({ name: 'title', content: event?.nameAr });
                  this.meta.addTag({
                    name: 'description',
                    content: event?.descriptionAr,
                  });
                  this.meta.updateTag(
                    { property: 'og:title', content: event?.nameAr },
                    'property="og:title"'
                  );
                  this.meta.updateTag(
                    { property: 'og:image', content: event?.image?.image?.url },
                    'property="og:image"'
                  );
                  this.eventLocationLink = `https://www.google.com/maps/search/?api=1&query=${event?.lat}%2C${event?.lng}`;
                  this.spinner.hide();
                })
              )
          )
        )
        .subscribe()
    );
  }

  checkBookAvailability():
    | 'available'
    | 'ended'
    | 'no-tickets'
    | 'CommingSoon'
    | 'SoldOut' {
    const today = new Date().getTime();
    const eventEnd =
      this.event.schedules[this.event.schedules.length - 1]?.endAt * 1000;
    const hasActiveTickets = this.event.tickets.some(
      (ticket: any) => ticket.status === 'ACTIVE'
    );
    const allInactive = this.event.tickets.every(
      (ticket: any) => ticket.status === 'INACTIVE'
    );
    if (this.event.eventSetting?.salesStatus === SalesStatusEnum.SALES_OPENED) {
      if (today > eventEnd) {
        return 'ended';
      }
      if ((!hasActiveTickets && allInactive) || !this.event.tickets.length) {
        return 'no-tickets';
      }
      return 'available';
    } else if (
      this.event.eventSetting?.salesStatus === SalesStatusEnum.SALES_CLOSED
    ) {
      return 'ended';
    } else if (
      this.event.eventSetting?.salesStatus === SalesStatusEnum.COMMING_SOON
    ) {
      return 'CommingSoon';
    } else if (
      this.event.eventSetting?.salesStatus === SalesStatusEnum.SOLD_OUT
    ) {
      return 'SoldOut';
    }

    return 'available';
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
